/**
 * main.js
 * Initializes and coordinates all the components of the Sign Customizer Tool.
 */

document.addEventListener('DOMContentLoaded', function() {
  // DOM Elements
  const customerNameInput = document.getElementById('customer-name');
  const processButton = document.getElementById('process-button');
  const previewGrid = document.getElementById('preview-grid');
  const stickyCart = document.getElementById('sticky-cart');
  
  // Initialize FileUploader
  const fileUploader = new FileUploader({
    maxSizeInMB: 5,
    allowedTypes: ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'],
    allowedExtensions: ['.png', '.jpg', '.jpeg', '.webp'],
    onFileUpload: handleFileUpload,
    onFileRemove: handleFileRemove
  });
  
  // Initialize CartManager
  const cartManager = new CartManager({
    prices: {
      small: 299,
      medium: 499,
      large: 699
    },
    onBuyNow: handleBuyNow
  });
  
  // Processing overlay element
  const processingOverlay = document.getElementById('processing-overlay');
  
  // Enable/disable process button based on form state
  function updateProcessButton() {
    const hasName = customerNameInput.value.trim() !== '';
    const hasLogo = fileUploader.hasUploadedFile();
    processButton.disabled = !(hasName && hasLogo);
  }
  
  // Add event listeners
  customerNameInput.addEventListener('input', updateProcessButton);
  processButton.addEventListener('click', startProcessing);
  
  function handleFileUpload() {
    updateProcessButton();
  }
  
  function handleFileRemove() {
    updateProcessButton();
    previewGrid.classList.add('d-none');
    stickyCart.classList.add('d-none');
  }
  
  function startProcessing() {
    // Show processing overlay
    processingOverlay.classList.remove('d-none');    
   
      setTimeout(() => updateProgressText("Uploading your logo / image"), 0);
      setTimeout(() => updateProgressText("Starting mockup creation.."), 2000);
      setTimeout(() => updateProgressText("Crafting your design mockup, believe us we are doing a lot of work in the background!"), 12000);
      setTimeout(() => updateProgressText("Doing final finishing..."), 30000);  
      submitForm();
    
    // Simulate processing time (10-15 seconds)
    // const processingTime = 50000;//Math.random() * 5000 + 10000; // 10-15 seconds
    // const processingTime = 100; // 10-15 seconds
    
  //   setTimeout(() => {
     
      
  //     // Apply logo to all preview items
  //     applyLogoToPreviews(fileUploader.getUploadedFile());
  //     
  //   }, processingTime);
   }
  
// Progress Bar Function
function updateProgressText(statusMessage) {
  let statustext = document.getElementById('processing-text');
    if (statustext) {
        statustext.innerHTML = statusMessage;
    }    
}
  
function endProcessing() {
  const processingOverlay = document.getElementById('processing-overlay');
  const previewGrid = document.getElementById('preview-grid');
  const stickyCart = document.getElementById('sticky-cart');

   // Hide processing overlay
      processingOverlay.classList.add('d-none');
      
      // Show preview grid and sticky cart
      previewGrid.classList.remove('d-none');
      stickyCart.classList.remove('d-none');

setTimeout(() => {
const headerOffset = 80;
      const previewPosition = previewGrid.getBoundingClientRect().top + window.pageYOffset - headerOffset;
  console.log('scrool value-0.---------'+previewPosition);
      window.scrollTo({
        top: previewPosition,
        behavior: 'smooth'
      });  
}, 2000);
  
// if (previewGrid) {  
//   const headerOffset = 80;  
//   // Get the position of the element relative to the page
//   const previewPosition = previewGrid.offsetTop - headerOffset;
//   console.log('scrool value----------'+previewPosition);
//   // Scroll smoothly to the element
//   window.scrollTo({
//     top: previewPosition,
//     behavior: 'smooth'
//   });
  
// } else {
//   console.error("Element with ID 'preview-grid' not found.");
// }
      // Scroll to previews with offset for sticky header
  //     const headerOffset = 80;
  //     const previewPosition = previewGrid.getBoundingClientRect().top + window.pageYOffset - headerOffset;
  // console.log(previewPosition);
  //     window.scrollTo({
  //       top: previewPosition,
  //       behavior: 'smooth'
  //     });
// const vh = window.innerHeight; // 1vh = 1% of viewport height
// const scrollAmount = vh * 200; // 200vh

// window.scrollTo({
//   top: window.pageYOffset + scrollAmount,
//   behavior: 'smooth'
// });
//
    //previewbox.classList.remove('d-none');
  
}
  const mockupApiURL = 'https://designs.quicksignage.com';  
  
  async function submitForm() {
          try {
              let fileInput = document.getElementById('logo-upload');
              let imageFile = fileInput.files[0];
              let clientName = document.getElementById('customer-name').value;
              let mockupApiURL = 'https://designs.quicksignage.com';
              let loaderbox = document.getElementById('loaderbox');
              let progress = document.getElementById('progress');
              let statustext = document.getElementById('status-text');
              let mucimg = document.getElementById("ah-muc");
              // let mockupResult = document.getElementById('mockupResult');
              // let ratingContent = document.getElementById('rating-content');
              let formData = new FormData();
              formData.append('image', imageFile);
              formData.append('name', clientName); 
             formData.append('template', 1);
            console.log("submit form function is running...");
              
  
              const response = await fetch(`${mockupApiURL}/api/webhook/generate/mockup/job/bulk`, {
                  method: 'POST',
                  body: formData
              });
  
              if (!response.ok) {
                  throw new Error("Server error, please try again.");
              }
                
              const result = await response.json();
            console.log(result);
              if (result.has_queued) {
                  let tryCount = 0;
                  while (tryCount < 2) {
                      await new Promise(resolve => setTimeout(resolve, 20000));
                      tryCount++;
                      const jobResult = await fetch(`${mockupApiURL}/api/webhook/generate/mockup/job/bulk/status/${result.template}`);
                      if (!jobResult.ok) {
                          const jobError = await jobResult.json().catch(() => null);
                          throw new Error(jobError?.message || "Mockup generation failed!");
                      }
  
                      const jobRecord = await jobResult.json();
                      if (jobRecord.remaining != 0) continue;
  
                      if (jobRecord.remaining === 0) {
                          if (jobRecord.failed != 0) {
                              throw new Error(jobRecord.message || "Mockup generation failed!");
                          }
                            
                          // mockupResult.style.display = "block";
                                    
                          const multiimages = document.getElementById('preview-grid');
                          multiimages.innerHTML = '';
                          const records = jobRecord.records;
  
                          let isFirstRow = true;
                            
                          for (const key in records) {
                            
                              if (records.hasOwnProperty(key)) {
                                  const data = records[key];
  
                                  const row = document.createElement('div');
                                  row.className = 'sign-section';
  
                                  // const wrapper = document.createElement('div');
                                  // wrapper.className = 'sign-section mb-5';
  
                                  const heading = document.createElement('h3');
                                  heading.classList.add('pt-4');
                                  heading.textContent = key.replace(/_/g, ' ');
                                  row.appendChild(heading);
  
                                  const imageContainer = document.createElement('div');
                                  imageContainer.className = 'preview-grid';
  
                                  if (Array.isArray(data.images)) {
                                      let imageHTML = '';
                                      data.images.forEach((imgUrl, index) => {
                                          const selectedClass = isFirstRow && index === 0 ? ' selectedmockup' : '';
                                          imageHTML += `
                                              <div class="preview-item${selectedClass}" purl="${data.signed}">
                                                  <img src="${imgUrl}" alt="${key} Image" style="width: 100%;">
                                              </div>
                                          `;
                                      });
                                      imageContainer.innerHTML = imageHTML;
  
                                      imageContainer.querySelectorAll('img').forEach(img => {
                                          img.addEventListener('click', function () {
                                              document.querySelectorAll('.preview-item').forEach(el => {
                                                  el.classList.remove('selectedmockup');
                                                
                                              });
                                              this.parentElement.classList.add('selectedmockup');
                                              this.parentElement.setAttribute('purl', data.signed);
  
                                              let buttons = document.querySelectorAll('.v-buttons');
                                              buttons.forEach(btn => btn.classList.remove('active'));
                                              document.getElementById('size_small').classList.add('active');
  
                                              applyPricesFromRow(row);
  
                                              const h3Text = row.querySelector('.col-md-12 h3')?.textContent || '';
                                              const selectedTypeContainer = document.getElementById('sign-section');
                                              selectedTypeContainer.textContent = h3Text;
                                          });
                                      });
            
                                      if (isFirstRow) {
                                          const h3Text = heading.textContent || '';
                                          const selectedTypeContainer = document.getElementById('sign-section');
                                          if (selectedTypeContainer) {
                                              selectedTypeContainer.textContent = h3Text;
                                          }
                                      }
                                      // scroll down
                                      let previewGrid = document.getElementById('preview-grid');
                                      const headerOffset = 80;
                                      const previewPosition = previewGrid.getBoundingClientRect().top + window.pageYOffset - headerOffset;
                                      console.log(previewPosition);
                                      window.scrollTo({
                                        top: previewPosition,
                                        behavior: 'smooth'
                                      });

                                    
                                  }
  
                                  if (data.prices && typeof data.prices === 'object') {
                                      Object.entries(data.prices).forEach(([size, price]) => {
                                          row.setAttribute(`data-price-${size.toLowerCase()}`, price);
                                      });
                                  }
  
                                  if (data.discounted && typeof data.discounted === 'object') {
                                      Object.entries(data.discounted).forEach(([size, price]) => {
                                          row.setAttribute(`data-discounted-price-${size.toLowerCase()}`, price);
                                      });
                                  }
  
                                  //wrapper.appendChild(imageContainer);
                                  row.appendChild(imageContainer);
                                  multiimages.appendChild(row);
  
                                  if (isFirstRow) {
                                      applyPricesFromRow(row);
                                      isFirstRow = false;
                                  }
                              }
                          }
                        endProcessing(); 
                      }
                  }
              }
          } catch (error) {
              console.error("Error:", error);
          }
      }

    // buy now
 /*   async function buyNow() {
    console.log("Button clicked!");

    const createLoader = document.getElementById("creating-loader");
    toggleLoader(createLoader, true);

    try {
        // Get the active variant title from the active button
        const activeButton = document.querySelector('.v-buttons.active');
        if (!activeButton) {
            throw new Error("No active variant selected!");
        }
        const selectedSize = activeButton.value;
       selectedVtitle = selectedSize.split(' ')[0];
        console.log(selectedSize+ " Selected Variant Title.....:", selectedVtitle);
        
      const selectedpurl = document.querySelector('.selectedmockup');
  if (selectedpurl) {
    const purl = selectedpurl.getAttribute('purl');
    console.log(purl); // or use it however you need
  } else {
    console.log('No selected mockup found.');
  }

      const productURL = selectedpurl.getAttribute('purl');
      
      console.log(productURL); 

        // Fetch product data from the product URL
        const productData = await fetchProductData(productURL);
        let selectedVid = null;

        if (productData && productData.variants) {
            console.log("Number of Variants:", productData.variants.length);      

            // Loop through variants to find the matching size
            for (let i = 0; i < productData.variants.length; i++) {
                const variant = productData.variants[i];
                console.log("Variant Size:", variant.size);

                if (selectedVtitle.toLowerCase() === variant.size.toLowerCase()) {
                    selectedVid = variant.id;
                    break;
                }
            }
        }

        if (!selectedVid) {
            throw new Error("Selected variant ID not found!");
        }

        // Construct the redirect URL with the selected variant ID
        const redirectUrl = `https://quicksignage.com/cart/clear?return_to=/cart/add?items[0][id]=${selectedVid}%26items[0][quantity]=1%26return_to=/checkout?discount=QS10OFF`;
        console.log("Redirect URL:", redirectUrl);

        // Redirect to the checkout page
       // location.href = redirectUrl;
    } catch (error) {
        console.error("Something went wrong! Please try again.", error.message);
    } finally {
        toggleLoader(createLoader, false);
    }
}*/
      
  function toggleLoader(loader, isVisible) {
      loader.style.display = isVisible ? "block" : "none";
  }
  
  async function fetchProductData(url) {
      try {
          const response = await fetch(url);
          const result = await response.json();
          console.log("Full API Response:", result);
  
          if (result.status !== "success") {
              throw new Error("API did not return a success status!");
          }
  
          return result;
      } catch (error) {
          throw new Error("Failed to fetch product data: " + error.message);
      }
  }


  
      // let previewGridSigns = document.querySelectorAll('#preview-grid .sign-section');
      // previewGridSigns.forEach(sign => {
      //   img.addEventListener('click', function (elm) {
      //     console.log(elm);
      //   })
      // })
      
      // function priceHandler(){
        
      //   imageContainer.querySelectorAll('img').forEach(img => {
      //       img.addEventListener('click', function () {
      //           document.querySelectorAll('.preview-item').forEach(el => {
      //               el.classList.remove('selectedmockup');
      //           });
      //           this.parentElement.classList.add('selectedmockup');

      //           let buttons = document.querySelectorAll('.v-buttons');
      //           buttons.forEach(btn => btn.classList.remove('active'));
      //           document.getElementById('size_small').classList.add('active');

      //           applyPricesFromRow(row);

      //           const h3Text = row.querySelector('.col-md-12 h3')?.textContent || '';
      //           const selectedTypeContainer = document.getElementById('sign-section');
      //           selectedTypeContainer.textContent = h3Text;
      //       });
      //   });
      // }

      // ✅ Apply both original and discounted prices

  // Find all size radio buttons
  // const radios = document.querySelectorAll('input[name="size"]');

  // radios.forEach(radio => {
  //   if (radio.checked) {
  //     // Get corresponding label
  //     const label = document.querySelector(`label[for="${radio.id}"]`);

  //     // Get discounted price from label attribute
  //     const discount = label.getAttribute('discprice');

  //     // Create and append the span
  //     const span = document.createElement('span');
  //     span.id = 'discounted';
  //     span.style.marginLeft = '10px'; // optional spacing
  //     span.textContent = `$${discount}`;
  //     label.appendChild(span);
  //   }
  // });

  // Apply logo to all preview items
  function applyLogoToPreviews(file) {
    const reader = new FileReader();
    
    reader.onload = function(e) {
      const logoUrl = e.target.result;
      
      // Get all preview items
      const previewItems = document.querySelectorAll('.preview-item');
      
      previewItems.forEach(item => {
        // Create logo overlay if it doesn't exist
        let logoOverlay = item.querySelector('.logo-overlay');
        if (!logoOverlay) {
          logoOverlay = document.createElement('div');
          logoOverlay.className = 'logo-overlay';
          item.appendChild(logoOverlay);
        }
        
        // Create or update logo image
        let logoImg = logoOverlay.querySelector('img');
        if (!logoImg) {
          logoImg = document.createElement('img');
          logoOverlay.appendChild(logoImg);
        }
        
        logoImg.src = logoUrl;
        logoImg.alt = 'Your Logo';
      });
    };
    
    reader.readAsDataURL(file);
  }
  
  function handleBuyNow(data) {
    const customerName = customerNameInput.value.trim();
    console.log('Proceeding to checkout:', {
      ...data,
      customerName
    });
    // Implement checkout functionality here
  }
  
  // For development/demo purposes - create dummy images
  createDummyImages();
});

// Development helper function to ensure images exist for demo purposes
function createDummyImages() {
  const dummyImages = {
    'acrylic-lightbox-1.jpg': '#2C3E50',
    'acrylic-lightbox-2.jpg': '#34495E',
    'acrylic-lightbox-3.jpg': '#2C3E50',
    'acrylic-lightbox-4.jpg': '#34495E',
    'metal-sign-1.jpg': '#2C3E50',
    'metal-sign-2.jpg': '#34495E',
    'metal-sign-3.jpg': '#2C3E50',
    'metal-sign-4.jpg': '#34495E',
    'backlit-acrylic-1.jpg': '#2C3E50',
    'backlit-acrylic-2.jpg': '#34495E',
    'backlit-acrylic-3.jpg': '#2C3E50',
    'backlit-acrylic-4.jpg': '#34495E'
  };
  
  Object.entries(dummyImages).forEach(([filename, color]) => {
    const images = document.querySelectorAll(`img[src$="${filename}"]`);
    if (images.length > 0) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      canvas.width = 400;
      canvas.height = 300;
      
      ctx.fillStyle = color;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
      ctx.lineWidth = 2;
      
      for (let i = 0; i < 5; i++) {
        const y = Math.floor(canvas.height / 6) * (i + 1);
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(canvas.width, y);
        ctx.stroke();
      }
      
      ctx.fillStyle = 'rgba(255, 255, 255, 0.3)';
      ctx.font = '16px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(filename.replace('.jpg', ''), canvas.width / 2, canvas.height / 2);
      
      const dataUrl = canvas.toDataURL('image/jpeg');
      images.forEach(img => {
        img.src = dataUrl;
      });
    }
  });
}
    // ✅ Apply both original and discounted prices
      function applyPricesFromRow(rowElement) {
          if (rowElement) {
              const small = rowElement.getAttribute('data-price-small') || 0;
              const medium = rowElement.getAttribute('data-price-medium') || 0;
              const large = rowElement.getAttribute('data-price-large') || 0;
      
              const dSmall = rowElement.getAttribute('data-discounted-price-small') || small;
              const dMedium = rowElement.getAttribute('data-discounted-price-medium') || medium;
              const dLarge = rowElement.getAttribute('data-discounted-price-large') || large;
      
              document.getElementById('size_small').setAttribute('orgprice', small);
              document.getElementById('size_small').setAttribute('discprice', dSmall);
      
              document.getElementById('size_medium').setAttribute('orgprice', medium);
              document.getElementById('size_medium').setAttribute('discprice', dMedium);
      
              document.getElementById('size_large').setAttribute('orgprice', large);
              document.getElementById('size_large').setAttribute('discprice', dLarge);
      
              document.getElementById('discounted').textContent = `$${dSmall}`;
              document.getElementById('original').textContent = `$${small}`;
          }
      }